// extracted by mini-css-extract-plugin
module.exports = {"ContentSection":"ContentSection_ContentSection___GaZW"};